import React, { useState } from "react"
import { Droplet } from "react-bootstrap-icons"
import { $selectedAccountId, $selectedAccountIdx } from "../../../common/accounts2"
import { $SiteColors } from "../../../common/config/company-atts"
import { $currAccCounters, sendCountersValue } from "../logics/counters"
interface ICountersListItem {
  typeName: string //тип счетчика
  number: string //номер счетчика
  dateLastVerif: string //дата последней поверки
  value:string //показания счетчика
  canSend:number
  id:number
}

//отрисовываем элемента из списка счетчиков
export const CounterListItem = ({
  typeName,
  number,
  dateLastVerif,
  value,
  canSend,
  id
}: ICountersListItem) => {
  let dt = new Date(dateLastVerif) //дата последней поверки
  dateLastVerif = isNaN(dt.getTime())
    ? dateLastVerif
    : dt.toLocaleDateString().replace(".", "-") //приводим к формату ГГГГ-ММ-ДД

  const [showInfo, setShowInfo] = useState(false)
  const [currentValue,setCurrentValue]=useState<number>(0)
  const infoClassName = showInfo
    ? "counters__info"
    : "counters__info counters__info_hidden"

  function showHideInfo() {
    setShowInfo(!showInfo)
  }
  const onValueChange=(e:React.ChangeEvent<HTMLInputElement>)=>{
    let value = e.target.value.replace(".","")
    if(value.split("")[0]==="0"){
      let newValues = value.split("")
      newValues.shift()
      value = newValues.join("")
    }
      if(value==="")
        setCurrentValue(0)
      if(isNaN(parseInt(value))) return
      setCurrentValue(parseInt(value))
  }
  const formatValue=(value:string|number)=>{
    let newValue = value.toString()
    while(newValue.length<4)
      newValue= "0"+newValue
    newValue = newValue.slice(0, newValue.length-3) + "." + newValue.slice(-3);
    
      return newValue
  }
  const onSendClick=(id:number, currentValue:number)=>{
    console.log(currentValue/1000)
    // console.log($selectedAccountId.getState())
    sendCountersValue({accountId:$selectedAccountId.getState(),
      id:id,
      value:currentValue/1000})
  }

  return (
      <li className="counters__el">
        <div className="counters__header" onClick={showHideInfo}>
          <div className="counters__icon-text">
            <div
              className="counters__drop-icon"
              style={{ fontSize: "30", color: "#EC607E" }}
            >
              <Droplet />
            </div>
            <p className="counters__text">{typeName}, №{number}</p>
          </div>
          <p className="counters__text counters__text_date">
            Последняя поверка от {dateLastVerif}
          </p>
        </div>
        <div className={infoClassName}>
          <div className="counters__info-all">
            <div className="counters__info-container">
              <p className="counters__text">Предыдущие показания:</p>
              <p className="counters__text counters__text_numbers">{formatValue(value+"000")}</p>
            </div>
            {canSend===1?
            <>
              <div className="counters__info-container">
                <p className="counters__text">Текущие показания:</p>
                <input className="counters__text counters__text_numbers counters__text_input" type="text" value={formatValue(currentValue)} onChange={e=>onValueChange(e)}/>
              </div>
              <div className="counters__info-container">
                <p className="counters__text">Расход:</p>
                <p className="counters__text counters__text_numbers">{formatValue(currentValue-(parseInt(value)*1000))}</p>
              </div>
            </>
            :
            <div className="counters__info-container">
            <p className="counters__text" style={{textAlign:"center"}}>Прием показаний осуществляется с 20 по 26 числа месяца </p>
            </div>
        }
          </div>
          {canSend===1?
          <button
          type="button"
          className="counters__button"
          onClick={()=>onSendClick(id,currentValue)}
          style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }}
          >
            Передать показания
          </button>
          :<></>}
        </div>
      </li>

  )
}
